/**
 * Generation section (sidebar context) → workflow category.
 *
 * `ImageGenerationContext` fetches `/api/user/workflows/list?category=...` with
 * the category this resolves to, so a missing entry does not fail loudly — the
 * section silently lists `Image` workflows instead of its own. Extracted from
 * the inline ternary chain so the mapping is unit-testable and so adding a
 * content type is a one-line change in one place.
 *
 * Categories mirror `WorkflowCategorySchema` ('Image' | 'Video' | 'Voice' |
 * '3D' | 'Text'). Contexts that are not generation sections (organization,
 * gallery, admin, …) never reach this and fall back to 'Image'.
 */
import type { ActiveSidebarContext } from '../contexts/SidebarContext';

export type WorkflowCategoryName = 'Image' | 'Video' | 'Voice' | '3D' | 'Text';

const CONTEXT_CATEGORIES: Partial<Record<ActiveSidebarContext, WorkflowCategoryName>> = {
  image: 'Image',
  video: 'Video',
  audio: 'Voice',
  text: 'Text',
  '3d': '3D',
};

/** Workflow category for a generation section; anything else falls back to 'Image'. */
export function resolveCategoryForContext(
  context: ActiveSidebarContext | null | undefined
): WorkflowCategoryName {
  if (!context) return 'Image';
  return CONTEXT_CATEGORIES[context] || 'Image';
}
